import { useQuery } from '@tanstack/react-query';
import { fromUnixTime, isPast } from 'date-fns';

import { DemioEventRequest, getDemioEvents } from '@arrived/api_v2';

import { MAX_STALE_TIME } from '../queries.utils';
import { demioKey } from './demio.keys';

export function useGetDemioEvents({ active = true }: DemioEventRequest = {}) {
  return useQuery(demioKey, () => getDemioEvents({ active }), {
    staleTime: MAX_STALE_TIME,
    select: (events) => events.filter((d) => d.status !== 'running' && !isPast(fromUnixTime(d.timestamp))),
  });
}
